<section>
  <p class="section-title">VÍNCULO COM EMPRESA</p>

  <!-- EMPRESA -->

  <mat-form-field
    appearance="outline"
    class="full-width"
    [class.error]="touchedEmpresa && !empresaSelecionada"
  >
    <mat-label>Vincular empresa*</mat-label>
    <input
      matInput
      type="text"
      [(ngModel)]="empresaDummyModel"
      name="empresaSelecionada"
      [value]="empresaSelecionada?.nomeFantasia || ''"
      readonly
      [disabled]="formBloqueado() || empresaSelecionada"
      (click)="!empresaSelecionada && abrirModalEmpresas()"
      [ngStyle]="!empresaSelecionada ? { cursor: 'pointer' } : {}"
    />
  </mat-form-field>

  <p *ngIf="touchedEmpresa && !empresaSelecionada" class="erro">
    Empresa obrigatória
  </p>

  <div class="endereco-empresa-selecionada-card" *ngIf="empresaSelecionada">
    <p>{{ empresaSelecionada?.nomeFantasia }}</p>

    @if(!formBloqueado()) {
    <img
      src="../../../../assets/svg/icons/trash.svg"
      (click)="abrirDesvincularEmpresa()"
      style="cursor: pointer"
    />
    }
  </div>

  <!-- ENDEREÇO -->
  <mat-form-field
    appearance="outline"
    class="full-width"
    [class.error]="
      touchedEndereco && empresaSelecionada && !enderecoSelecionado
    "
  >
    <mat-label>Vincular endereço*</mat-label>
    <input
      matInput
      type="text"
      [value]="enderecoSelecionado?.labelEndereco || ''"
      readonly
      [disabled]="!empresaSelecionada || enderecoSelecionado"
      (click)="abrirModalEnderecos()"
      [ngStyle]="
        empresaSelecionada && !enderecoSelecionado
          ? { cursor: 'pointer' }
          : {}
      "
    />
  </mat-form-field>

  <p
    *ngIf="touchedEndereco && empresaSelecionada && !enderecoSelecionado"
    class="erro"
  >
    Endereço obrigatório
  </p>

  <div class="endereco-empresa-selecionada-card" *ngIf="enderecoSelecionado">
    <p>{{ enderecoSelecionado.labelEndereco }}</p>

    @if(!formBloqueado()) {
    <img
      src="../../../../assets/svg/icons/trash.svg"
      (click)="abrirDesvincularEndereco()"
      style="cursor: pointer"
    />
    }
  </div>
</section>
